import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";
import Logo from "./Logo";
import RoadLine from "./RoadLine";
import { COMPANY } from "../content/company";

const NAV = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/services", label: "Services" },
    { to: "/drivers", label: "Drivers" },
    { to: "/contact", label: "Contact" },
];

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-night-deep text-white">
        <RoadLine testId="footer-road-line" className="opacity-60" />
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 md:py-20">
            <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
                <div className="md:col-span-5">
                    <Logo testId="footer-logo" className="text-base" />
                    <p className="mt-6 font-heading text-lg font-medium text-white/90">
                        DRIVEN BY FAITH.
                    </p>
                    <p className="mt-3 flex items-center gap-2 text-sm text-white/60">
                        <MapPin size={15} className="text-brand" /> {COMPANY.city}
                    </p>
                </div>

                <div className="md:col-span-3">
                    <h3 className="font-heading text-xs font-semibold uppercase tracking-[0.25em] text-brand">
                        Company
                    </h3>
                    <ul className="mt-5 space-y-3">
                        {NAV.map((l) => (
                            <li key={l.to}>
                                <Link
                                    to={l.to}
                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="text-sm text-white/70 transition-colors hover:text-white"
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <h3 className="font-heading text-xs font-semibold uppercase tracking-[0.25em] text-brand">
                        Get In Touch
                    </h3>
                    <ul className="mt-5 space-y-3 text-sm text-white/70">
                        <li className="flex items-center gap-2" data-testid="footer-email">
                            <Mail size={15} className="text-brand shrink-0" />
                            {/* EDIT: email in src/content/company.js */}
                            {COMPANY.email ? (
                                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email-link" className="transition-colors hover:text-white">
                                    {COMPANY.email}
                                </a>
                            ) : (
                                <span className="text-white/60 italic">Email — coming soon</span>
                            )}
                        </li>
                    </ul>
                    {/* EDIT: social media links in src/content/company.js */}
                    <div className="mt-6 flex gap-4 text-xs uppercase tracking-widest text-white/60" data-testid="footer-social">
                        <span>Facebook</span>
                        <span>Instagram</span>
                        <span>LinkedIn</span>
                    </div>
                </div>
            </div>

            <div className="mt-14 border-t border-white/10 pt-8 text-center">
                <p data-testid="footer-legal-line" className="text-xs text-white/60">
                    © {new Date().getFullYear()} {COMPANY.name} · USDOT {COMPANY.usdot}
                </p>
                <p data-testid="footer-verse" className="mx-auto mt-3 max-w-xl text-xs italic leading-relaxed text-white/50">
                    Proverbs 16:3 — “Commit to the LORD whatever you do, and he will establish your plans.”
                </p>
                <div className="mt-5 flex justify-center gap-6 text-xs text-white/60">
                    <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-white/80">
                        Privacy Policy
                    </Link>
                    <Link to="/terms" data-testid="footer-terms-link" className="transition-colors hover:text-white/80">
                        Terms &amp; Conditions
                    </Link>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
